import { render } from "./TituloIntro.vue?vue&type=template&id=6ad13f43"
import script from "./TituloIntro.vue?vue&type=script&lang=js"
export * from "./TituloIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__